import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { ec2Get, ec2Post, ec2Delete } from '../utils/ec2api';
import { analizarSms } from '../utils/smsSegments';

export default function CampanaPush() {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [url, setUrl] = useState('/Ofertas');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [targetMsisdn, setTargetMsisdn] = useState('');

  // Promos
  const [promos, setPromos] = useState([]);
  const [subs, setSubs] = useState([]);
  const [showSubs, setShowSubs] = useState(false);
  const [promoTitulo, setPromoTitulo] = useState('');
  const [promoDesc, setPromoDesc] = useState('');
  const [promoLink, setPromoLink] = useState('');
  const [promoFechaFin, setPromoFechaFin] = useState('');
  const [promoFile, setPromoFile] = useState(null);
  const [subiendoPromo, setSubiendoPromo] = useState(false);

  useEffect(() => { loadPromos(); loadSubs(); }, []);

  const loadPromos = async () => {
    try {
      setPromos(await ec2Get('/promos'));
    } catch (e) { console.error(e); }
  };

  const loadSubs = async () => {
    try {
      const data = await ec2Get('/subscribers');
      setSubs(Array.isArray(data) ? data : []);
    } catch (e) { console.error(e); }
  };

  const smsInfo = analizarSms(body);

  const enviarPush = async () => {
    if (!title || !body) { toast.warn('Escribe título y mensaje'); return; }
    // Si va dirigido a un numero (posible SMS), bloquear mensajes de 2+ segmentos
    if (targetMsisdn && smsInfo.excede) {
      toast.error(
        `El mensaje es muy largo para 1 SMS (${smsInfo.encoding}: máx ${smsInfo.limite} caracteres). ` +
        `Usa ${smsInfo.unidades} de ${smsInfo.limite}. Acórtalo o quita acentos/emojis.`
      );
      return;
    }
    setEnviando(true);
    setResultado(null);
    try {
      const payload = { title, body, url };
      if (targetMsisdn) payload.msisdn = targetMsisdn;
      const r = await ec2Post('/push', payload);
      setResultado(r);
      if (r.sms_sent) toast.success(`📱 SMS enviado a ${targetMsisdn}`);
      else toast.success(`Enviado a ${r.sent} de ${r.total}`);
    } catch { toast.error('Error al enviar'); }
    finally { setEnviando(false); }
  };

  const subirPromo = async () => {
    if (!promoTitulo || !promoFile || !promoFechaFin) {
      toast.warn('Completa título, archivo y fecha de expiración');
      return;
    }
    setSubiendoPromo(true);
    try {
      const isVideo = promoFile.type.startsWith('video');
      // 1. Obtener presigned URL
      const uploadData = await ec2Post('/upload_url', { filename: promoFile.name, content_type: promoFile.type });
      const { upload_url, key } = uploadData;

      // 2. Subir archivo a S3
      await fetch(upload_url, {
        method: 'PUT',
        headers: { 'Content-Type': promoFile.type },
        body: promoFile,
      });

      // 3. Crear promo en DB
      await ec2Post('/promos', {
          titulo: promoTitulo,
          descripcion: promoDesc,
          media_key: key,
          media_type: isVideo ? 'video' : 'image',
          link: promoLink,
          fecha_fin: promoFechaFin,
      });

      toast.success('Promoción creada');
      setPromoTitulo(''); setPromoDesc(''); setPromoLink(''); setPromoFechaFin(''); setPromoFile(null);
      loadPromos();
    } catch (e) {
      console.error(e);
      toast.error('Error al crear promoción');
    } finally { setSubiendoPromo(false); }
  };

  const eliminarPromo = async (id) => {
    try {
      await ec2Delete('/promos', { id });
      toast.success('Promoción eliminada');
      loadPromos();
    } catch { toast.error('Error'); }
  };

  const inputStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ccc', marginBottom: '10px', boxSizing: 'border-box' };

  return (
    <div style={{ marginTop: '20px' }}>

      {/* SUSCRIPTORES */}
      <div style={{ background: '#fff', borderRadius: '16px', padding: '16px 20px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: '20px' }}>
        <div
          onClick={() => setShowSubs(!showSubs)}
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
        >
          <span style={{ fontSize: '15px', fontWeight: '600', color: '#1b2938' }}>📱 Dispositivos registrados</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px', fontWeight: '800', color: '#0056b3' }}>{subs.length}</span>
            <span style={{ color: '#9ca3af', fontSize: '14px' }}>{showSubs ? '▲' : '▼'}</span>
          </div>
        </div>
        {showSubs && (
          <div style={{ marginTop: '14px' }}>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
              {Object.entries(subs.reduce((acc, s) => { acc[s.device] = (acc[s.device] || 0) + 1; return acc; }, {})).map(([device, count]) => (
                <div key={device} style={{ padding: '8px 14px', background: '#f0f4f8', borderRadius: '10px', fontSize: '13px' }}>
                  <span style={{ fontWeight: '700', color: '#1b2938' }}>{count}</span>
                  <span style={{ color: '#6b7280', marginLeft: '6px' }}>{device}</span>
                </div>
              ))}
            </div>
            <div style={{ maxHeight: '150px', overflowY: 'auto', fontSize: '12px', color: '#9ca3af' }}>
              {subs.map(s => (
                <div key={s.id} style={{ padding: '4px 0', borderBottom: '1px solid #f3f4f6' }}>
                  {s.msisdn ? `📞 ${s.msisdn} · ` : ''}{s.device} · {new Date(s.created_at).toLocaleDateString()}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* PUSH */}
      <h2>📢 Enviar Push</h2>
      <input placeholder="📞 Número (vacío = todos)" type="tel" value={targetMsisdn} onChange={(e) => setTargetMsisdn(e.target.value)} style={inputStyle} />
      <input placeholder="Título" value={title} onChange={(e) => setTitle(e.target.value)} style={inputStyle} />
      <textarea placeholder="Mensaje" value={body} onChange={(e) => setBody(e.target.value)} rows={2} style={inputStyle} />
      {/* Contador de caracteres SMS (solo relevante cuando se envia a un numero) */}
      {targetMsisdn && body && (
        <div style={{
          marginTop: '-6px', marginBottom: '10px', fontSize: '12px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          color: smsInfo.excede ? '#dc2626' : '#6b7280',
        }}>
          <span>
            {smsInfo.unidades}/{smsInfo.limite} · {smsInfo.encoding}
            {smsInfo.encoding === 'UCS-2' ? ' (con acentos/emoji)' : ''}
          </span>
          <span style={{ fontWeight: 700 }}>
            {smsInfo.excede
              ? `⚠️ ${smsInfo.segmentos} SMS — se rechazará`
              : '✅ 1 SMS'}
          </span>
        </div>
      )}
      <select value={url} onChange={(e) => setUrl(e.target.value)} style={inputStyle}>
        <option value="/Ofertas">Ofertas</option>
        <option value="/Consulta">Recarga y Consulta</option>
        <option value="/Esim">Compra eSIM</option>
        <option value="/Ofertasinternacional">eSIM Internacional</option>
        <option value="/Promos">Promociones</option>
        <option value="/Referidos">Invita a un amigo</option>
        <option value="https://monkeyphone.net">🌐 Página oficial</option>
      </select>
      <button onClick={enviarPush} disabled={enviando || (targetMsisdn && smsInfo.excede)} className="orange-button" style={{ width: '100%' }}>
        {enviando ? '⏳ Enviando...' : '🚀 Enviar Push'}
      </button>
      {resultado && (
        <div style={{ marginTop: '10px', padding: '10px', background: '#dcfce7', borderRadius: '8px', textAlign: 'center', fontSize: '14px' }}>
          {resultado.sms_sent
            ? `📱 SMS enviado a ${targetMsisdn} (sin suscripción push)`
            : `✅ Enviado: ${resultado.sent} · Fallido: ${resultado.failed} · Total: ${resultado.total}`
          }
        </div>
      )}

      <hr style={{ margin: '24px 0', border: 'none', borderTop: '1px solid #e2e8f0' }} />

      {/* PROMOS */}
      <h2>🎬 Crear Promoción</h2>
      <input placeholder="Título de la promo" value={promoTitulo} onChange={(e) => setPromoTitulo(e.target.value)} style={inputStyle} />
      <textarea placeholder="Descripción (opcional)" value={promoDesc} onChange={(e) => setPromoDesc(e.target.value)} rows={2} style={inputStyle} />
      <input placeholder="Link (opcional)" value={promoLink} onChange={(e) => setPromoLink(e.target.value)} style={inputStyle} />
      <label style={{ display: 'block', marginBottom: '10px', fontSize: '14px', color: '#4b5563' }}>
        Expira el:
        <input type="datetime-local" value={promoFechaFin} onChange={(e) => setPromoFechaFin(e.target.value)} style={{ ...inputStyle, marginTop: '4px' }} />
      </label>
      <label style={{ display: 'block', marginBottom: '10px', fontSize: '14px', color: '#4b5563' }}>
        Imagen o Video:
        <input type="file" accept="image/*,video/*" onChange={(e) => setPromoFile(e.target.files[0])} style={{ ...inputStyle, marginTop: '4px' }} />
      </label>
      <button onClick={subirPromo} disabled={subiendoPromo} className="orange-button" style={{ width: '100%' }}>
        {subiendoPromo ? '⏳ Subiendo...' : '📤 Crear Promoción'}
      </button>

      {/* LISTA */}
      {promos.length > 0 && (
        <>
          <h3 style={{ marginTop: '20px' }}>Promos activas ({promos.length})</h3>
          {promos.map((p) => (
            <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px', background: '#f9fafb', borderRadius: '10px', marginBottom: '8px' }}>
              {p.media_type === 'video' ? (
                <video src={p.media_url} style={{ width: 60, height: 60, borderRadius: 8, objectFit: 'cover' }} muted />
              ) : (
                <img src={p.media_url} alt="" style={{ width: 60, height: 60, borderRadius: 8, objectFit: 'cover' }} />
              )}
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{p.titulo}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Expira: {new Date(p.fecha_fin).toLocaleDateString()}</div>
              </div>
              <div style={{ display: 'flex', gap: '6px' }}>
                <button onClick={async () => {
                  try {
                    await ec2Post('/push', { title: `🔥 ${p.titulo}`, body: p.descripcion || 'Mira nuestra nueva promoción', url: '/Promos' });
                    toast.success('Push enviado');
                  } catch { toast.error('Error'); }
                }} style={{ background: '#1b2938', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: 13 }}>📢</button>
                <button onClick={() => eliminarPromo(p.id)} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: 13 }}>✕</button>
              </div>
            </div>
          ))}
        </>
      )}

      {/* Padding para footer */}
      <div style={{ height: 80 }} />
    </div>
  );
}
